import { combineEpics } from 'redux-observable';

import {
	fetchServiceSettingEpic,
} from './service-setting-epics';

import {
	fetchPlatformSettingEpic,
} from './platform-setting-epics';

import {
	idLoginEpic,
	anonymousLoginEpic,
	checkAuthEpic,
	fetchMeEpic,
	heartbeatEpic,
	updateMeLanguageEpic,
} from './auth-epics';

import {
	fetchArticlesEpic,
} from './article-epics';

import {
	createConversationEpic,
} from './conversation-epics';

import {
	createFileConversationReplyEpic,
	createFormFileConversationReplyEpic,
	createQAFormFileConversationReplyEpic,
	createQuickFormConversationReplyEpic,
} from './conversation-reply-epics';

import {
	translateTextsEpic,
} from './translate-epics';

import {
	getConversationSilenceEpic,
} from './conversation-error-epics';

import {
	fetchCaptchaEpic,
	detectCaptchaEpic,
	detectCaptchaSuccessEpic,
	detectCaptchaFailedEpic,
} from './captcha-epics';

const epics = combineEpics(
	// Service Setting
	fetchServiceSettingEpic,
	// Platform Setting
	fetchPlatformSettingEpic,
	// Auth
	idLoginEpic,
	anonymousLoginEpic,
	checkAuthEpic,
	updateMeLanguageEpic,
	// Article
	fetchArticlesEpic,
	// Conversation
	createConversationEpic,
	// Conversation Reply
	createFileConversationReplyEpic,
	createFormFileConversationReplyEpic,
	createQAFormFileConversationReplyEpic,
	createQuickFormConversationReplyEpic,
	// Translate
	translateTextsEpic,
	// Conversation Error
	getConversationSilenceEpic,
	// Me
	fetchMeEpic,
	// Captcha
	fetchCaptchaEpic,
	detectCaptchaEpic,
	detectCaptchaSuccessEpic,
	detectCaptchaFailedEpic,
	// Heartbeat
	heartbeatEpic,
);

export default epics;
